import { Tile, TileStripe } from "@dash/tile";
import { useTheme } from "@emotion/react";
import type { FC } from "react";
import { Link } from "react-router-dom-v5-compat";
import tinycolor from "tinycolor2";

import { Uuid } from "@megaron/uuid";

type Props = {
  title: string;
  invoiceIssuer: string;
  invoiceNumber: string;
  threadUuid: Uuid;
};

export const SupportTicketInvoiceTile: FC<Props> = ({ title, invoiceIssuer, invoiceNumber, threadUuid }) => {
  const theme = useTheme();
  const color = theme.colors.primary;

  return (
    <Link
      to={`/faktury/watki/${threadUuid}`}
      css={{
        ":hover": {
          textDecoration: "none",
          h4: {
            textDecoration: "underline",
          },
        },
      }}
    >
      <Tile
        stripe={<TileStripe color={color} />}
        css={{
          borderRadius: theme.smallBorderRadius,
          border: `1px solid ${tinycolor(color).setAlpha(0.1)}`,
        }}
      >
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            width: "100%",
          }}
        >
          <span
            css={{
              fontSize: "16px",
              color,
            }}
          >
            {title}
          </span>
          <span css={{ fontSize: "14px", color: theme.colors.secondaryText }}>{invoiceIssuer}</span>
          <span css={{ fontSize: "12px" }}>{invoiceNumber}</span>
        </div>
      </Tile>
    </Link>
  );
};
